import { Component, OnInit } from '@angular/core';
import { SettingServices } from '../setting.services';
import { Subject, Subscription } from 'rxjs';
import { KGridHelper } from '../../../_helpers/k-grid.class';
import { EmployeePostHeadViewModel, EmployeePreHeadViewModel } from '../setting.class';
import { NotificationService } from '../../../_services/notification.service';
import { LocalService } from '../../../_services/local.service';
import { AuthenticationService } from '../../../_services/authentication.service';
import { ExportExcelService } from '../../../_services/export-excel.service';
import { ActivatedRoute } from '@angular/router';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { ExtentionSpliter } from '../../../_helpers/extention-spliter';

@Component({
  selector: 'app-employee-head',
  templateUrl: './employee-head.component.html',
  styleUrls: ['./employee-head.component.scss']
})
export class EmployeeHeadComponent implements OnInit {
  public searchEvent = new Subject<any>();
  public searchSubcription: Subscription = null;
  public preGrid: KGridHelper = new KGridHelper();
  public preSearchTerm = '';


  public postGrid: KGridHelper = new KGridHelper();
  public postSearchTerm = '';

  public preHead: EmployeePreHeadViewModel = new EmployeePreHeadViewModel();
  public postHead: EmployeePostHeadViewModel = new EmployeePostHeadViewModel();
  public preHeadList = [];
  public filteredpreHeadList = [];
  public deleting = false;
  public deletedPreHeadId: number;
  public deletedPostHeadId: number;
  public openPreHeadDialog = false;
  public openPostHeadDialog = false;
  public openDilogConfirmation = false;
  public openPostDilogConfirmation = false;
  public isExcelExport: boolean = false;

  toggle: boolean = false;
  name = 'slideToggle';
  id = 'materialSlideToggle';
  checked = false;
  disabled = false;
  label = 'Toggle On/Off';
  labelledby = 'Some Other Text';
  uploadFlag: boolean = false;
  selectedFile: any;

  constructor(public _notificationService: NotificationService,
    public _settingService: SettingServices,
    public _localService: LocalService,
    public _authenticationServie: AuthenticationService,
    private _exportToExcelService: ExportExcelService,
    private route: ActivatedRoute) {
  }


  ngOnInit() {

    this.getEmployeePreHead();
    //this.getEmployeePostHead();
    this.initializeProps();
  }

  onChange(event) {
    this.toggle = event;
    this.selectedFile = undefined;
    this.uploadFlag = false;
  }


    attachExcelFile(event) {
      let extention = ExtentionSpliter(event.target.files[0].name);
      if (extention !== '.csv') {
        this.uploadFlag = true;
        return;
      }
      else {
        this.uploadFlag = false;
        this.selectedFile = event.target.files[0];
      }
    }
    

     uploadPreHeadExcel() {
      debugger
        this._settingService.savePreHeadFromExcel(this.selectedFile).subscribe(
          (res: any) => {
            debugger
            this.close();
            this.getEmployeePreHead();
            this._notificationService.notify("success", "Import Successful");
          },
          (err) => {
            console.log(err);
            this.close();
            this._notificationService.notify("danger", err.error,"",10000);
            // this.saving = false;
          }
        );
      }

      uploadPostHeadExcel() {
        debugger
        this._settingService.savePostHeadFromExcel(this.selectedFile).subscribe(
          (res: any) => {
            debugger
            this.close();
            this.getEmployeePostHead();
            this._notificationService.notify("success", "Import Successful");
          },
          (err) => {
            console.log(err);
            this.close();
            this._notificationService.notify("danger", err.error,"",10000);
            // this.saving = false;
          }
        );
      }

  private initializeProps() {
    this.preGrid.loading = false;
    this.preGrid.pageSize = 20;
    this.preGrid.pageSizes = [20, 50, 100];

    this.postGrid.loading = false;
    this.postGrid.pageSize = 20;
    this.postGrid.pageSizes = [20, 50, 100];
  }

  public close() {

    this.openPreHeadDialog = false;
    this.openPostHeadDialog = false;
    this.openDilogConfirmation = false;
    this.openPostDilogConfirmation = false;
    this.selectedFile = undefined;
    this.uploadFlag = false;
    this.toggle = false;
  }

  public restForm() {
   this.preHead = new EmployeePreHeadViewModel();
   this.postHead= new EmployeePostHeadViewModel();
  }
  public getEmployeePreHead() {
    this._settingService.getEmployeePreHead(this.preGrid.skip, this.preGrid.pageSize, this.preGrid.searchQuery, this.preGrid.hfId, this.preGrid.geoLvlCode, this.preGrid.hfType, this.preGrid.stockId, this.preSearchTerm).subscribe((res: any) => {
      debugger;
      if (res) {
        console.log(res);
        this.preGrid.data = [];
        this.preGrid.data = res.res;
        this.preGrid.totalRecords = res.tc;
        this.preGrid.gridView = { data: this.preGrid.data, total: this.preGrid.totalRecords };
        this.preGrid.loading = false;
      }
    }, err => {
      debugger;

      this._notificationService.notify("danger", err.msg);

    });
  }

  getEmployeePreHeadSearchTerm(e) {
    if (this.preSearchTerm !== ' ') {
      this._settingService.getEmployeePreHead(this.preGrid.skip, this.preGrid.pageSize, this.preGrid.searchQuery, this.preGrid.hfId, this.preGrid.geoLvlCode, this.preGrid.hfType, this.preGrid.stockId, this.preSearchTerm).subscribe((res: any) => {
        if (res) {
          console.log(res);
          this.preGrid.data = [];
          this.preGrid.data = res.res;
          this.preGrid.totalRecords = res.tc;
          this.preGrid.gridView = { data: this.preGrid.data, total: this.preGrid.totalRecords };
          this.preGrid.loading = false;
        }
      }, (error) => {
        console.log(error);
      });
    } else {
      this.ngOnInit();
    }
  }

  public getEmployeePostHead() {
    this._settingService.getEmployeePostHead(this.postGrid.skip, this.postGrid.pageSize, this.postGrid.searchQuery, this.postGrid.hfId, this.postGrid.geoLvlCode, this.postGrid.hfType, this.postGrid.stockId, this.postSearchTerm).subscribe((res: any) => {
      debugger;
      if (res) {
        console.log(res);
        this.postGrid.data = [];
        this.postGrid.data = res.res;
        this.postGrid.totalRecords = res.tc;
        this.postGrid.gridView = { data: this.postGrid.data, total: this.postGrid.totalRecords };
        this.postGrid.loading = false;
      }
    }, err => {
      debugger;

      this._notificationService.notify("danger", err.msg);

    });
  }

  getEmployeePostHeadSearchTerm(e) {
    if (this.postSearchTerm !== ' ') {
      this._settingService.getEmployeePostHead(this.postGrid.skip, this.postGrid.pageSize, this.postGrid.searchQuery, this.postGrid.hfId, this.postGrid.geoLvlCode, this.postGrid.hfType, this.postGrid.stockId, this.postSearchTerm).subscribe((res: any) => {
        if (res) {
          console.log(res);
          this.postGrid.data = [];
          this.postGrid.data = res.res;
          this.postGrid.totalRecords = res.tc;
          this.postGrid.gridView = { data: this.postGrid.data, total: this.postGrid.totalRecords };
          this.postGrid.loading = false;
        }
      }, (error) => {
        console.log(error);
      });
    } else {
      this.ngOnInit();
    }
  }


  public RemoveEmployeePreHead(e) {
    this.deletedPreHeadId = e;
    this.openDilogConfirmation = true;
  }

  public ConfirmEmployeePreHeadDelete() {
    this._settingService.removeEmployeePreHead(this.deletedPreHeadId).subscribe((res: any) => {
      this.deletedPreHeadId = null;
      this.openDilogConfirmation = false;
      this._notificationService.notify("success", "Delete Successful");

      this.getEmployeePreHead();
    }, err => {
      this._notificationService.notify("danger", err.error);

    });
  }

  public RemoveEmployeePostHead(e) {
    debugger
    this.deletedPostHeadId = e;
    this.openPostDilogConfirmation = true;
  }

  public ConfirmEmployeePostHeadDelete() {
    debugger
    this._settingService.removeEmployeePostHead(this.deletedPostHeadId).subscribe((res: any) => {
      this.deletedPostHeadId = null;
      this.openPostDilogConfirmation = false;
      this._notificationService.notify("success", "Delete Successful");

      this.getEmployeePostHead();
    }, err => {
      this._notificationService.notify("danger", err.error);

    });
  }

  preExportToExcel() {
    this.isExcelExport = true;
    let excelArr = [];

    for (let i = 0; i < this.preGrid.data.length; i++) {
      let obj = {
        Name: this.preGrid.data[i].Name,
      }
      excelArr.push(obj);
    }
    this.isExcelExport = false;
    this._exportToExcelService.exportAsExcelFile(excelArr, 'EmployeePreHead');
    console.log('new array', excelArr);
  }

  postExportToExcel() {
    this.isExcelExport = true;
    let excelArr = [];

    for (let i = 0; i < this.postGrid.data.length; i++) {
      let obj = {
        Name: this.postGrid.data[i].Name,
        PreHead: this.postGrid.data[i].FK_EmployeePreHead.Name,
      }
      excelArr.push(obj);
    }
    this.isExcelExport = false;
    this._exportToExcelService.exportAsExcelFile(excelArr, 'EmployeePostHead');
    console.log('new array', excelArr);
  }

  public OpenDialogForPreHead(){
    this.openPreHeadDialog = true;
  }

  public savePreHead(){
     debugger;
        this._settingService.saveEmployeePreHead(this.preHead).subscribe((res: any) => {
          this.preHead = new EmployeePreHeadViewModel();
          this.getEmployeePreHead();
          this._notificationService.notify("success", "Save Successfully");
    
        }, err => {
          debugger
          this._notificationService.notify("danger", err.error.msg);
    
        });
        
  }

  onPreHeadSubmit(action: string) {
    // Handle "Save" functionality
    if (action === 'save') {
      // Save the data
      this.savePreHead();
      this.close();  // Close the popup on Save
    } 
    // Handle "Save & New" functionality
    else if (action === 'saveNew') {
      // Save the data
      this.savePreHead();
      this.restForm();
    }
  }

  public OpenPreHeadDialog(item){
    this.openPreHeadDialog = true;
    this.preHead = item;
  }

  public OpenDialogForPostHead(){
    this.openPostHeadDialog = true;
    this.LoadPreHeadForm();
  }

  public savePostHead(){
    debugger;
       this._settingService.saveEmployeePostHead(this.postHead).subscribe((res: any) => {
        this.getEmployeePostHead();
         this._notificationService.notify("success", "Save Successfully");
       }, err => {
         debugger
         this._notificationService.notify("danger", err.error.msg);
   
       });
       
 }

 onPostHeadSubmit(action: string) {
    // Handle "Save" functionality
    if (action === 'save') {
      // Save the data
      this.savePostHead();
      this.restForm();
      this.close();  // Close the popup on Save
    } 
    // Handle "Save & New" functionality
    else if (action === 'saveNew') {
      // Save the data
      this.savePostHead();
      this.restForm();
    }

}

 public OpenPostHeadDialog(item){
  debugger
   this.openPostHeadDialog = true;
   this.LoadPreHeadForm();
   this.postHead = item;
 }



 public LoadPreHeadForm() {
  debugger
  this.filteredpreHeadList = this.preHeadList = [];
  this._settingService.loadPreHead().subscribe((res: any) => {
    debugger;
    this.filteredpreHeadList = this.preHeadList = res.FK_EmployeePreHead;
  }, err => {

    this._notificationService.notify("danger", err.msg);

  });
}

onPreHeadFilter(value: string): void {
  debugger;
  // Perform filtering based on the input value
  this.filteredpreHeadList = this.preHeadList.filter(
    (user) => user.Name.toLowerCase().includes(value.toLowerCase())  // Case-insensitive filtering
  );
}
  public preChangePagesize(value: any) {
    this.preGrid.pageSize = +value;
    this.preGrid.skip = 0;
    this.getEmployeePreHead();
  }

  public postChangePagesize(value: any) {
    this.postGrid.pageSize = +value;
    this.postGrid.skip = 0;
    this.getEmployeePostHead();
  }

  public preSortChange(sort: SortDescriptor[]): void {
    if (sort[0].field == 'asd') { return; }
    this.preGrid.sort = sort;
    this.preSortData();
  }

  public postSortChange(sort: SortDescriptor[]): void {
    if (sort[0].field == 'asd') { return; }
    this.postGrid.sort = sort;
    this.postSortData();
  }

  private preSortData() {
    this.preGrid.gridView = {
      data: orderBy(this.preGrid.data, this.preGrid.sort),
      total: this.preGrid.totalRecords
    };
  }

  private postSortData() {
    this.postGrid.gridView = {
      data: orderBy(this.postGrid.data, this.postGrid.sort),
      total: this.postGrid.totalRecords
    };
  }

  public prePageChange(event: PageChangeEvent): void {
    this.preGrid.skip = event.skip;
    this.getEmployeePreHead();
  }

  public postPageChange(event: PageChangeEvent): void {
    this.postGrid.skip = event.skip;
    this.getEmployeePostHead();
  }

  dowonloadPreHeadTemplate() {
    window.open('assets/exl/PreHeadTemplate.csv', '_blank');
  }

  dowonloadPostHeadTemplate() {
    window.open('assets/exl/PostHeadTemplate.csv', '_blank');
  }

}
